import { render, staticRenderFns } from "./SignoutView.vue?vue&type=template&id=7989e4b8&"
import script from "./SignoutView.vue?vue&type=script&lang=js&"
export * from "./SignoutView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports